import { connect } from 'react-redux';
// import {  } from '../reducers/auth.reducers';
import {
  updateNotificationEntryStateAction,
  loadNotificationCenterEntriesAction,
  setNotificationStates } from '../../reducers/notification.reducers';
import NotificationCenterPopover from './notification-center-popup';

const mapDispatchToProps = dispatch => ({
  updateState: states => dispatch(updateNotificationEntryStateAction(states)),
  setNotificationStates: states => dispatch(setNotificationStates(states)),
  loadNotifications: () => dispatch(loadNotificationCenterEntriesAction()),
});

const mapStateToProps = state => ({
  notifications: state.notification.notificationCenterEntries,
  config: state.authentication.config,
});

export default connect(mapStateToProps, mapDispatchToProps)(NotificationCenterPopover);



// WEBPACK FOOTER //
// ./src/app/main/notification-center/notification-center-popover.container.js